// from general.js
/* global isMobileDevice */

import { showClassroomPhotoUploader } from '../../teacherclassroomphoto/teacherClassroomPhotoPopup.js';


$('body').on('click', '.js-classroom-photo-upload', function (event) {
    if (!isMobileDevice) {
        event.preventDefault();
        showClassroomPhotoUploader(this, event);
    }
});
